import React from 'react';
import { StatCard } from '../shared';

interface WidgetTourProps {
  tourRate: number;
  trend: number;
}

export const WidgetTour: React.FC<WidgetTourProps> = ({ tourRate, trend }) => (
  <StatCard
    label="Tour Invite Rate"
    value={`${tourRate.toFixed(0)}%`}
    trend={trend}
  />
);
